import { render, staticRenderFns } from "./courseDelete.vue?vue&type=template&id=2194891f&scoped=true"
import script from "./courseDelete.vue?vue&type=script&lang=js"
export * from "./courseDelete.vue?vue&type=script&lang=js"
import style0 from "./courseDelete.vue?vue&type=style&index=0&id=2194891f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2194891f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2194891f')) {
      api.createRecord('2194891f', component.options)
    } else {
      api.reload('2194891f', component.options)
    }
    module.hot.accept("./courseDelete.vue?vue&type=template&id=2194891f&scoped=true", function () {
      api.rerender('2194891f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantInfo/courseDelete.vue"
export default component.exports